import type { DayRange, TimeRange } from '@brighterly/lib-core-types/activation/enums'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'
import { ShortDaysOfWeek } from '@brighterly/lib-core-types/options/enums'

import { useCurrentTime } from '@entities/customer/@x/activation'
import { formatDate } from '@shared/lib/format'

/**
 * Flattens a day-keyed schedule (store shape) into the wire shape the
 * /activation POST validator expects — a list of `{ day, from, to }` entries
 * with times in 24h `HH:mm` (DateFormat.DefaultTime). Shared by old and new
 * activation flows so both endpoints stay in sync.
 */
export const getScheduleList = (rawSlots: Record<ShortDaysOfWeek, TimeRange[]>): DayRange[] => {
  const { currentDate } = useCurrentTime()

  const getSlot = (day: ShortDaysOfWeek, slots: TimeRange[]): DayRange[] => {
    return slots.map(slot => ({
      day,
      from: formatDate(`${currentDate.value} ${slot.from}`, DateFormat.DefaultTime),
      to: formatDate(`${currentDate.value} ${slot.to}`, DateFormat.DefaultTime),
    }))
  }

  return [
    ...getSlot(ShortDaysOfWeek.Monday, rawSlots[ShortDaysOfWeek.Monday]),
    ...getSlot(ShortDaysOfWeek.Tuesday, rawSlots[ShortDaysOfWeek.Tuesday]),
    ...getSlot(ShortDaysOfWeek.Wednesday, rawSlots[ShortDaysOfWeek.Wednesday]),
    ...getSlot(ShortDaysOfWeek.Thursday, rawSlots[ShortDaysOfWeek.Thursday]),
    ...getSlot(ShortDaysOfWeek.Friday, rawSlots[ShortDaysOfWeek.Friday]),
    ...getSlot(ShortDaysOfWeek.Saturday, rawSlots[ShortDaysOfWeek.Saturday]),
    ...getSlot(ShortDaysOfWeek.Sunday, rawSlots[ShortDaysOfWeek.Sunday]),
  ]
}
